export class CarouselHeroAbout extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            mainCarousel: "[js-hero-carousel]",
            thumbButton: "[js-about-hero-button]",
        };
    }

    connectedCallback() {
        this.mainCarousel = this.querySelector(this.selectors.mainCarousel);
        this.thumbButtons = this.querySelectorAll(this.selectors.thumbButton);

        this._setListeners();
    }

    _setListeners = () => {
        this.thumbButtons.forEach((button) => {
            button.addEventListener("click", this._moveCarousel);
        });

        this.mainCarousel.swiper.on("slideChange", this._updateButtons);
    };

    _moveCarousel = (evt) => {
        this.mainCarousel.swiper.slideTo(evt.target.dataset.index);

        this.thumbButtons.forEach((button) => {
            if (button.classList.contains("active")) {
                button.classList.remove("active");
            }
        });

        evt.target.classList.add("active");
    };

    _updateButtons = () => {
        var activeIndex = this.mainCarousel.swiper.activeIndex;

        this.thumbButtons.forEach((button) => {
            if (button.classList.contains("active")) {
                button.classList.remove("active");
            }

            if (button.dataset.index === activeIndex) {
                button.classList.add("active");
            }
        });
    };
}
